export default (function (_ref) {
  var colors = _ref.colors;
  return {
    '@global': {
      '.handle-bars': {
        backgroundColor: colors.secondary
      },
      '.handle.active .handle-bars': {
        backgroundColor: '#013b1d'
      },
      '.bar.bar-0': {
        backgroundColor: colors.secondary
      },
      '.bar.bar-1': {
        backgroundColor: '#89ab2a'
      },
      '.step-emphasized-light': {
        '&::before': {
          backgroundColor: '#89ab2a'
        }
      },
      '.step-emphasized-dark': {
        '&::before': {
          backgroundColor: colors.secondary
        }
      }
    },
    sliderBarActiveLoanLimit: function sliderBarActiveLoanLimit(_ref2) {
      var barHeight = _ref2.barHeight,
          height = _ref2.height;
      return {
        height: "".concat(barHeight, "px"),
        position: 'absolute',
        top: "".concat((height - barHeight) / 2, "px"),
        backgroundColor: colors.yellow,
        zIndex: 1
      };
    },
    handleLoanLimit: {
      backgroundColor: "".concat(colors.yellow, " !important")
    }
  };
});